<template>
  <div class="header">
    <div class="header-logotypes">
      <close-menu-logo
        class="logo-mobile"
        v-if="isMenuOpen"
        @click="toggleMenu"
      />
      <open-menu-logo class="logo-mobile" v-else @click="toggleMenu" />
      <company-text-logo class="logo" />
    </div>
    <div class="navigation">
      <div class="user">
        <div class="user-logo"></div>
        <div class="user-login" @click="goToProfileMenu">
          {{ currentEmail }}
        </div>
        <profile-logo class="logotype profile-logo" />
        <notifications-container />
        <exit-logo @click="logOut" class="logotype exit-logo" />
      </div>
    </div>
  </div>
</template>

<script>
import AuthService from "../../services/authService";

import CompanyTextLogo from '@/components/icons/CompanyTextLogo.vue'
import ExitLogo from '../icons/ExitLogo'
import OpenMenuLogo from '../icons/OpenMenuLogo'
import CloseMenuLogo from '../icons/CloseMenuLogo'
import ProfileLogo from '../icons/ProfileLogo'
import NotificationsContainer from "../notifications/NotificationsContainer";

export default {
  components: {
    ProfileLogo,
    CloseMenuLogo,
    OpenMenuLogo,
    ExitLogo,
    CompanyTextLogo,
    NotificationsContainer,
  },
  props: {
    isMenuOpen: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    currentEmail() {
      return this.$store.getters.GET_CURRENT_EMAIL
    },
  },
  methods: {
    async logOut() {
      try {
        await AuthService.logout()

        this.$store.dispatch('SET_LOGGED_IN', false)

        await this.$router.push('/login')
      } catch (e) {
        console.error(e)
      }
    },
    toggleMenu() {
      this.$emit('toggle')
    },
    goToProfileMenu() {
      this.$router.push('/profile')
    },
  },
}
</script>

<style scoped lang="scss">
.header {
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;

  &-logotypes {
    display: flex;
    align-items: center;
  }

  .logo {
    height: 40px;
    width: 143px;
    @media only screen and (max-width: $tablet-size) {
      height: 28px;
      width: 109px;
    }
  }

  .logo-mobile {
    display: none;
    margin-right: 30px;
    width: 20px;
    cursor: pointer;
    @media only screen and (max-width: $tablet-size) {
      display: block;
    }
  }

  .navigation {
    .user {
      display: flex;
      align-items: center;

      .user-login:hover {
        color: #91c027;
        cursor: pointer;
      }

      .user-logo {
        width: 40px;
        height: 40px;
        margin-right: 10px;
        background: no-repeat center url(../../assets/images/user-icon.png);
        @media only screen and (max-width: $tablet-size) {
          display: none;
        }
      }

      .user-login {
        font-weight: 600;
        font-size: 15px;
        line-height: 20px;
        color: #152e39;
        vertical-align: center;
        height: 20px;
        @media only screen and (max-width: $tablet-size) {
          display: none;
        }
      }

      .logotype {
        cursor: pointer;
      }

      .profile-link {
        display: flex;
        align-items: center;
        text-decoration: none;

        &:hover .user-login {
          color: #91c027;
        }
      }

      .notification-logo {
        margin: 0 25px 0 60px;
        @media only screen and (max-width: $tablet-size) {
          margin: 0 0 0 27px;
        }
      }

      .profile-logo {
        display: none;
        @media only screen and (max-width: $tablet-size) {
          display: block;
        }
      }

      .exit-logo {
        @media only screen and (max-width: $tablet-size) {
          display: none;
        }
      }
    }
  }
}
</style>
